/** Ids dos institutos previdenciários, como a API recebe e retorna (tipoSolicitacao / idInstituto). */
export const TIPO_INSTITUTO = {
  RESGATE: 1,
  AUTOPATROCINIO: 2,
  BPD: 3,
  PORTABILIDADE: 4,
} as const;
